import { render, staticRenderFns } from "./productGrouping.vue?vue&type=template&id=abba8b20&scoped=true&"
import script from "./productGrouping.vue?vue&type=script&lang=js&"
export * from "./productGrouping.vue?vue&type=script&lang=js&"
import style0 from "./productGrouping.vue?vue&type=style&index=0&id=abba8b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abba8b20",
  null
  
)

export default component.exports